module.exports = __webpack_public_path__ + "static/media/snake_signature.3e332695.jpg";